import React from "react";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { formatDateDDMMYYYY } from "../../../utils/commonFunctions";
import moment from "moment";

const ValidationPopup = ({
  openWarningModal,
  errorVerification,
  details,
  application,
  updateDetailsHandler,
  reUploadHandlerPan,
  setOpenWarningModal,
  fileType,
  reUploadHandler,
  aadharAgeError,
}) => {
  const errorList = Object.keys(errorVerification || {})
    .map((key) => errorVerification[key])
    .join("");

  const DOB = application?.responses?.find(
    (ele) => ele?.label === "Date of Birth"
  )?.value;

  const OCR_NAME = application?.aadharCardImage?.[0]?.OCRData?.response?.name;
  const OCR_DOB =
    application?.aadharCardImage?.[0]?.OCRData?.response?.date_of_birth;

  return (
    <Modal
      title=""
      className="p-0 custom_modal__"
      centered
      open={openWarningModal}
      closable={false}
      width={600}
      closeIcon={null}
      footer={null}
    >
      <div>
        <div className="modal-header d-flex justify-content-between align-items-center active-color-modal text-white w-100">
          <h5
            className="modal-title text-white text-capitalize font-weight-bold"
            style={{ fontSize: "18px", fontWeight: 400 }}
          >
            Alert
          </h5>
        </div>
        <div className="row py-3 px-4 ">
          <div className="w-100">
            <div className="col-12 p-3">
              <div className="d-flex __custom_row">
                <div style={{ flex: "1 1", width: "100%" }}>
                  <h4
                    className="__custom_heading text-center"
                    style={{ marginTop: "1rem" }}
                  >
                    {fileType === "aadhar" ? (
                      <>
                        {aadharAgeError ? (
                          "Age Validation Failed"
                        ) : (
                          <>
                            {details?.verificationDetails?.[0]?.errorReason ===
                            "ocr"
                              ? "Document Verification Failed"
                              : "Name Mismatch Alert"}
                          </>
                        )}
                      </>
                    ) : (
                      <>Name Mismatch Alert</>
                    )}
                  </h4>
                  <p
                    className="font-weight-bold text-danger"
                    style={{ marginTop: "1.6rem", textAlign: "center" }}
                  >
                    {fileType === "aadhar"
                      ? aadharAgeError
                        ? "You must be at least 18 years old as per your Aadhaar details."
                        : details?.verificationDetails?.[0]?.errorDetails || ""
                      : errorList}
                  </p>
                  <div
                    className="d-flex justify-content-center gap-1"
                    style={{
                      marginTop: "2.1rem",
                      paddingBottom: "2.1rem",
                      borderBottom: "1px solid grey",
                    }}
                  >
                    {fileType === "aadhar" && (
                      <>
                        {aadharAgeError ? null : (
                          <>
                            {details?.verificationDetails?.[0]
                              ?.digiWithProfile === false &&
                              details?.verificationDetails?.[0]?.errorReason ===
                                "profile" && (
                                <button
                                  className={`__btn px-3 text-white rounded font-weight-bold __initial_accepted`}
                                  onClick={async () => {
                                    if (updateDetailsHandler) {
                                      await updateDetailsHandler();
                                    }
                                    setOpenWarningModal(false);
                                  }}
                                >
                                  {" "}
                                  <CheckOutlined
                                    style={{
                                      borderRadius: "50%",
                                      padding: 2,
                                      marginRight: "5px",
                                    }}
                                    className={"__initial_accepted_icon"}
                                  />
                                  Update
                                </button>
                              )}
                          </>
                        )}
                      </>
                    )}
                    <button
                      className={`__btn px-3 text-white rounded font-weight-bold __initial_rejected`}
                      onClick={async () => {
                        if (fileType === "aadhar") {
                          if (reUploadHandler) {
                            await reUploadHandler();
                          }
                        } else {
                          if (reUploadHandlerPan) {
                            await reUploadHandlerPan();
                          }
                        }
                        setOpenWarningModal(false);
                      }}
                    >
                      <CloseOutlined
                        style={{
                          borderRadius: "50%",
                          padding: 2,
                          marginRight: "5px",
                        }}
                        className={"__initial_rejected_icon"}
                      />
                      Re Upload
                    </button>
                  </div>
                  {aadharAgeError ? null : (
                    <>
                      <div className="px-2 mb-2">
                        <div className="mt-2">
                          <div style={{ textTransform: "capitalize" }}>
                            {fileType === "aadhar" ? (
                              <>
                                {details?.verificationDetails?.[0]
                                  ?.errorReason === "ocr"
                                  ? "Name on Document : "
                                  : "Job Application Name : "}
                              </>
                            ) : (
                              <>Job Application Name : </>
                            )}
                            <strong>
                              {fileType === "aadhar" ? (
                                <>
                                  {details?.verificationDetails?.[0]
                                    ?.errorReason === "ocr"
                                    ? OCR_NAME || "Not Found"
                                    : application?.name || "Not Found"}
                                </>
                              ) : (
                                <>{application?.name || "Not Found"}</>
                              )}
                            </strong>
                          </div>
                          <div style={{ textTransform: "capitalize" }}>
                            {fileType === "aadhar"
                              ? "Aadhar card Name"
                              : "PAN card Name"}{" "}
                            :{" "}
                            <strong>
                              {details?.aadharVerificationDetails?.data
                                ?.full_name || "Not Found"}
                            </strong>
                          </div>
                        </div>
                      </div>
                      {fileType === "aadhar" && (
                        <div className="px-2 mb-2">
                          <div className="mt-2">
                            <div style={{ textTransform: "capitalize" }}>
                              <>
                                {details?.verificationDetails?.[0]
                                  ?.errorReason === "ocr"
                                  ? "Date of Birth on Document : "
                                  : "Date of Birth on Application : "}
                              </>

                              <strong>
                                <>
                                  {details?.verificationDetails?.[0]
                                    ?.errorReason === "ocr"
                                    ? OCR_DOB
                                      ? moment(OCR_DOB, "DD/MM/YYYY").format(
                                          "DD-MM-YYYY"
                                        )
                                      : "Not Found"
                                    : DOB
                                    ? formatDateDDMMYYYY(DOB)
                                    : "Not Found"}
                                </>
                              </strong>
                            </div>
                            <div style={{ textTransform: "capitalize" }}>
                              Aadhar card Date of Birth :{" "}
                              <strong>
                                {details?.aadharVerificationDetails?.data?.dob
                                  ? formatDateDDMMYYYY(
                                      details?.aadharVerificationDetails?.data
                                        ?.dob
                                    )
                                  : "Not Found"}
                              </strong>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                  <div style={{ borderTop: "1px solid grey" }} className="px-2">
                    <p className="text-muted" style={{ marginTop: "1rem" }}>
                      {fileType === "aadhar" ? (
                        <>
                          {aadharAgeError ? (
                            <>
                              By clicking on Re Upload, you will need to upload
                              your document again.
                            </>
                          ) : (
                            <>
                              {details?.verificationDetails?.[0]
                                ?.digiWithProfile === false &&
                              details?.verificationDetails?.[0]?.errorReason ===
                                "profile" ? (
                                <>
                                  By clicking update, your name and date of
                                  birth in our system will be updated to{" "}
                                  <strong>
                                    {
                                      details?.aadharVerificationDetails?.data
                                        ?.full_name
                                    }
                                  </strong>{" "}
                                  and{" "}
                                  <strong>
                                    {details?.aadharVerificationDetails?.data
                                      ?.dob
                                      ? formatDateDDMMYYYY(
                                          details?.aadharVerificationDetails
                                            ?.data?.dob
                                        )
                                      : ""}
                                  </strong>{" "}
                                  as per your Aadhar card.
                                </>
                              ) : (
                                <>
                                  By clicking on Re Upload, you will need to
                                  upload your document again.
                                </>
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          Your PAN name does not match the name in your
                          application. Please re-upload the correct PAN card or
                          ensure your details are accurate.
                        </>
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ValidationPopup;
